import Vue from 'vue'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
import './scrollHorizontally' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'

window.isSlide = false

Vue.use(VueFullPage)
